import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { uploadProjectsDirectory } from '../../app/store/actions/projectsDirectory';
import FIELDS from '../../data/fields';
import ROUTES from '../../data/routes';
import { history } from '../../routers/AppRouter';
import HeaderComponent from '../table/header/headerComponent';

class ProjectsDirectoryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectsDirectoryId: null,
      opportunities: '',
      efkCode: null,
      projectName: '',
      director: '',
      segment: '',
      usdmmInvestment: null,
      stage: '',
      region: '',
      objective: '',
      location: '',
      descriptionOfWorksAndActivities: '',
      usefulLife: '',
      mainTeams: '',
      investment: '',
      timeline: '',
      statusAtSea: '',
      others: '',
      message: '',
      success: '',
    };
  }

  componentDidMount = () => {
    if (this.props.back.location.selectedLine) {
      this.setTheVariables(this.props.back.location.selectedLine);
    }
  }

  setTheVariables = (selectedLine) => {
    this.setState({
      projectsDirectoryId: selectedLine.id,
      opportunities: selectedLine.opportunities,
      efkCode: selectedLine.efkCode,
      projectName: selectedLine.projectName,
      director: selectedLine.director,
      segment: selectedLine.segment,
      usdmmInvestment: selectedLine.usdmmInvestment,
      stage: selectedLine.stage,
      region: selectedLine.region,
      objective: selectedLine.objective,
      location: selectedLine.location,
      descriptionOfWorksAndActivities: selectedLine.descriptionOfWorksAndActivities,
      usefulLife: selectedLine.usefulLife,
      mainTeams: selectedLine.mainTeams,
      investment: selectedLine.investment,
      timeline: selectedLine.timeline,
      statusAtSea: selectedLine.statusAtSea,
      others: selectedLine.others,
    });
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  updateData = async () => {
    const {
      projectsDirectoryId, opportunities, efkCode, projectName,
      director, segment, usdmmInvestment, stage, region,
      objective, location, descriptionOfWorksAndActivities,
      usefulLife, mainTeams, investment, timeline, statusAtSea,
      others,
    } = this.state;
    try {
      await this.props.uploadProjectsDirectory({
        projectsDirectoryId,
        opportunities,
        efkCode,
        projectName,
        director,
        segment,
        usdmmInvestment,
        stage,
        region,
        objective,
        location,
        descriptionOfWorksAndActivities,
        usefulLife,
        mainTeams,
        investment,
        timeline,
        statusAtSea,
        others,
      });
      await this.setState({
        success: I18n.t('changeMade'),
        message: '',
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          success: '',
          message: messageError,
        });
      } else {
        this.setState({
          success: '',
          message: I18n.t('erroFetch'),
        });
      }
    }
  }

  goBack = () => history.push(ROUTES.PROJECTS_DIRECTORY);

  render() {
    const {
      opportunities, efkCode, projectName, director,
      segment, usdmmInvestment, stage, region, objective,
      location, descriptionOfWorksAndActivities, usefulLife,
      mainTeams, investment, timeline, statusAtSea, others,
    } = this.state;

    return (
      <div className="form-main">
        <HeaderComponent
          title={I18n.t('UpdateProjectsDirectory')}
        />
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('opportunities')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('opportunities', e.target.value)}
              value={opportunities}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('efkCode')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="number"
              placeholder=""
              onChange={e => this.setValue('efkCode', e.target.value)}
              value={efkCode}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('projectName')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('projectName', e.target.value)}
              value={projectName}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('director')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('director', e.target.value)}
              value={director}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('segment2')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('segment', e.target.value)}
              value={segment}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('usdmmInvestment')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="number"
              placeholder=""
              onChange={e => this.setValue('usdmmInvestment', e.target.value)}
              value={usdmmInvestment}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('region')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('region', e.target.value)}
              value={region}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('stage')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('stage', e.target.value)}
              value={stage}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('objective')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max_projects_directory}
              type="text"
              placeholder=""
              onChange={e => this.setValue('objective', e.target.value)}
              value={objective}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('location')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max_projects_directory}
              type="text"
              placeholder=""
              onChange={e => this.setValue('location', e.target.value)}
              value={location}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('descriptionOfWorksAndActivities')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max_projects_directory}
              type="text"
              placeholder=""
              onChange={e => this.setValue('descriptionOfWorksAndActivities', e.target.value)}
              value={descriptionOfWorksAndActivities}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('usefulLife')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('usefulLife', e.target.value)}
              value={usefulLife}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('mainTeams')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('mainTeams', e.target.value)}
              value={mainTeams}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('investment')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('investment', e.target.value)}
              value={investment}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('timeline')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max_projects_directory}
              type="text"
              placeholder=""
              onChange={e => this.setValue('timeline', e.target.value)}
              value={timeline}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('statusAtSea')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max_projects_directory}
              type="text"
              placeholder=""
              onChange={e => this.setValue('statusAtSea', e.target.value)}
              value={statusAtSea}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('others')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max_projects_directory}
              type="text"
              placeholder=""
              onChange={e => this.setValue('others', e.target.value)}
              value={others}
            />
          </div>
          <div className="row margin-left-0 margin-top-10">
            <button
              className="btn btn-warning margin-right-15"
              type="button"
              onClick={this.goBack}
            >
              {I18n.t('return')}
            </button>

            <button
              className="btn btn-dark margin"
              type="button"
              onClick={this.updateData}
            >
              {I18n.t('update')}
            </button>
          </div>
        </form>
        {!!this.state.success && <p className="color-green margin-top-10">{this.state.success}</p>}
        {!!this.state.message && <p className="color-red margin-top-10">{this.state.message}</p>}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadProjectsDirectory: projectsDirectoryParameter => dispatch(
    uploadProjectsDirectory(projectsDirectoryParameter),
  ),
});

const mapStateToProps = (/* state */) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsDirectoryForm);
